import { render, staticRenderFns } from "./SideNavBtn.vue?vue&type=template&id=21f5b685&scoped=true"
import script from "./SideNavBtn.vue?vue&type=script&lang=js"
export * from "./SideNavBtn.vue?vue&type=script&lang=js"
import style0 from "./SideNavBtn.vue?vue&type=style&index=0&id=21f5b685&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f5b685",
  null
  
)

export default component.exports